export const Break = {
  print: () => 'break'
};
